var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1264 2.0509C7.06143 2.0509 4.58252 4.52981 4.58252 7.59478C4.58252 11.7527 10.1264 17.8905 10.1264 17.8905C10.1264 17.8905 15.6703 11.7527 15.6703 7.59478C15.6703 4.52981 13.1914 2.0509 10.1264 2.0509ZM6.16649 7.59478C6.16649 5.40891 7.94053 3.63488 10.1264 3.63488C12.3123 3.63488 14.0863 5.40891 14.0863 7.59478C14.0863 9.87569 11.8054 13.2892 10.1264 15.4196C8.47907 13.305 6.16649 9.85193 6.16649 7.59478Z",
    fill: "#787D83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1264 9.57466C11.2199 9.57466 12.1064 8.68821 12.1064 7.59471C12.1064 6.50121 11.2199 5.61475 10.1264 5.61475C9.03295 5.61475 8.14648 6.50121 8.14648 7.59471C8.14648 8.68821 9.03295 9.57466 10.1264 9.57466Z",
    fill: "#787D83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.8bf63a9f92c62cb0c3faa27c3f4c59e7.svg";
export { ForwardRef as ReactComponent };